import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { MediaItemModel } from '../../../../models/media-item.model';

@Component({
  selector: 'slider-dialog-image',
  templateUrl: './slider-dialog-image.component.html',
})
export class SliderDialogImageComponent {

  @ViewChild('imageElement') public set imageElement(element: ElementRef) {
    if (element) {
      this.containerWidth = element.nativeElement.offsetWidth;
      this.containerHeight = element.nativeElement.offsetHeight;

      // How many times the image's width/height is greater than the container's
      this.factorX = element.nativeElement.naturalWidth / this.containerWidth;
      this.factorY = element.nativeElement.naturalHeight / this.containerHeight;

      this.zoomable = this.factorY > 1 || this.factorX > 1;
      this.cdr.detectChanges();
      element.nativeElement.addEventListener('mousemove', (e) => {
        this.getCoordinates(e);
      });
    }
  }

  @Input() public image: MediaItemModel = null;
  @Output() public imageZoomed: EventEmitter<{zoomed: boolean}> = new EventEmitter<{zoomed: boolean}>();

  public posX: number = 0;
  public posY: number = 0;
  public zoomedIn: boolean = false;
  public containerWidth: number = 760;
  public containerHeight: number = 550;
  public factorX: number = 1;
  public factorY: number = 1;
  public zoomable: boolean = false;

  /**
   * Constructor
   *
   * @param {ChangeDetectorRef} cdr
   */
  public constructor(private cdr: ChangeDetectorRef) { }

  /**
   * Gets the cursor coordinates relative to the image
   *
   * @param e
   *
   * @return void
   */
  public getCoordinates(e): void {
    const rect =  e.target.getBoundingClientRect();
    this.posX = Math.max(0, Math.round(e.clientX - rect.left)) * this.factorX;
    this.posY = Math.max(0, Math.round(e.clientY - rect.top)) * this.factorY;
  }

  /**
   * Toggles the zoomed state
   *
   * @return void
   */
  public zoomedInToggle(): void {
    this.zoomedIn = !this.zoomedIn;
    this.imageZoomed.next({zoomed: this.zoomedIn});
  }
}
